module.exports = __webpack_public_path__ + "static/media/Bay2.8ae009be.JPG";